import React, { createContext, useContext, useEffect, useState } from "react";
import * as Actions from "../../constants/baseUrl";
import axios from "axios";

const AuthProviderContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [googleClient, setGoogleClient] = useState(null);
  const [linkedInClient, setLinkedInClient] = useState(null);

const fetchAuthProviders = async () => {
  try {
    const response = await axios.get(`${Actions.AUTH_URL}Auth/auth-providers`);
    return response.data;
  } catch (error) {
    console.error("Error fetching auth providers:", error);
    return null;
  }
};


  useEffect(() => {
    const fetchProviders = async () => {
      const providers = await fetchAuthProviders();
      if (providers) {
        providers.forEach((provider) => {
          if (provider.providerName === "Google") {
            setGoogleClient(provider.clientId);
          } else if (provider.providerName === "LinkedIn") {
            setLinkedInClient(provider.clientId);
          }
        });
      }
    };
    fetchProviders();
  }, []);

  return (
    <AuthProviderContext.Provider value={{ googleClient, linkedInClient }}>
      {children}
    </AuthProviderContext.Provider>
  );
};

export const useAuthProviders = () => useContext(AuthProviderContext);
